import { useState } from "react";
import { IconButton, Box } from "~/common/mui";
import { ImageWithFallback } from "../MediaLibraryItem/MediaLibraryItem";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";

import { previewImageSx, previewTwoImageSx } from "./previewStyles";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export const PdfPreview = ({ pages }: { pages: string[] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const isTablet = useIsMinTabletSize();

  if (pages.length === 0) {
    return null;
  }
  const previewCount = isTablet ? 2 : 1;
  const visiblePages = pages.slice(currentIndex, currentIndex + previewCount);
  const noOfPages = previewCount === 2 ? Math.ceil(pages.length / 2) : pages.length;
  const currentPage = previewCount === 2 ? currentIndex / 2 + 1 : currentIndex + 1;

  const renderImage = (src: string, i: number) => (
    <ImageWithFallback
      previewUrl={src}
      mediaType={`Preview page ${currentIndex + i + 1}`}
      previewImageSx={previewCount === 2 ? previewTwoImageSx : previewImageSx}
    />
  );

  const handlePrev = () => {
    if (previewCount === 1) {
      setCurrentIndex((prev) => prev - 1);
    } else {
      setCurrentIndex((prev) => Math.max(prev - previewCount, 0));
    }
  };

  const handleNext = () => {
    if (previewCount === 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      setCurrentIndex((prev) => Math.min(prev + previewCount, pages.length - (pages.length % 2 === 0 ? 2 : 1)));
    }
  };

  return (
    <>
      {previewCount === 2 ? (
        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.25 }}>
          {visiblePages.map(renderImage)}
        </Box>
      ) : (
        visiblePages.map(renderImage)
      )}

      {noOfPages > 1 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            position: "absolute",
            top: "90%",
          }}
        >
          <IconButton
            size="small"
            variant="contained"
            color="secondary"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              e.preventDefault();
              handlePrev();
            }}
            disabled={currentPage === 1}
          >
            <KeyboardArrowLeftIcon  />
          </IconButton>
          {currentPage} / {noOfPages}
          <IconButton
            size="small"
            variant="contained"
            color="secondary"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              e.preventDefault();
              handleNext();
            }}
            disabled={currentPage === noOfPages}
          >
            <KeyboardArrowRightIcon  />
          </IconButton>
        </Box>
      )}
    </>
  );
};
